export default "__VITE_ASSET__Cq7A94s$__"